import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import LoginIcon from '@mui/icons-material/Login';

export const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            OpsPilot
          </Typography>
          <Typography variant="h6" color="textSecondary" align="center">
            AI-Powered Investigation Platform
          </Typography>
          <Typography variant="body2" color="textSecondary" align="center">
            Sign in with your Cloud2 account
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<LoginIcon />}
            onClick={() => login()}
            sx={{
              mt: 2,
              textTransform: 'none',
              fontSize: '1rem',
              padding: '12px 32px',
            }}
          >
            Sign in
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};
